import SEOHead from '@/components/feature/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSearch from './components/HeroSearch';
import QuickLinks from './components/QuickLinks';
import CategorySection from './components/CategorySection';
import HotArticles from './components/HotArticles';
import { siteInfo } from '@/mocks/articles';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://vfufj.cn',
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '北京',
      addressCountry: 'CN',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://vfufj.cn',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://vfufj.cn/category/remenzixun?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51网址导航是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51网址导航是一个综合性上网导航平台，提供网址导航123快捷入口、热门资讯、吃瓜事件等内容，让您快速访问常用网站和了解最新网络热点。',
        },
      },
      {
        '@type': 'Question',
        name: '如何使用网址导航123？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的搜索框搜索想要访问的网站，也可以点击常用网址快捷入口直接跳转。我们还提供分类导航，帮助您快速找到感兴趣的内容。',
        },
      },
      {
        '@type': 'Question',
        name: '51网址导航有哪些特色功能？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51网址导航集成了123导航、导航123等数字标识导航服务，提供网址123易记好用的上网入口。同时提供热门资讯、吃瓜事件、科技数码、生活百科等多维度内容，一站式满足您的上网需求。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="51网址导航 | 网址导航123快捷入口 - 上网从这里开始"
        description="51网址导航提供网址导航123快捷入口，集成123导航、导航123等数字标识导航服务。网址123，易记好用的上网导航平台，为您提供网址导航、热点资讯、吃瓜事件一站式服务。"
        keywords="51网址导航, 网址导航123, 123导航, 导航123, 网址123, 上网导航, 导航网站, 在线导航"
        canonicalUrl="/"
        structuredData={organizationSchema}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Header />
        <main>
          <HeroSearch />
          <QuickLinks />
          <CategorySection />
          <HotArticles />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-6xl mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">
                为什么选择51网址导航？
              </h2>
              <p className="text-foreground-600 text-sm mb-8 max-w-xl mx-auto">
                作为专业的网址导航123平台，我们致力于为用户提供简单便捷的上网体验
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                {[
                  { icon: 'ri-speed-up-line', title: '快速访问', desc: '一键直达常用网站，省去记忆复杂网址的烦恼' },
                  { icon: 'ri-shield-check-line', title: '安全可靠', desc: '所有推荐网站均经过安全审核，保障您的上网安全' },
                  { icon: 'ri-global-line', title: '全面覆盖', desc: '涵盖新闻、视频、购物、社交等各大领域热门网站' },
                ].map((item, idx) => (
                  <div key={idx} className="p-6 bg-background-50 rounded-xl border border-background-200/70">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl text-primary-600 mx-auto mb-4">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-500">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-6xl mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">
                联系我们
              </h2>
              <p className="text-foreground-600 text-sm mb-8">
                如有任何建议或合作意向，欢迎通过以下方式联系我们
              </p>
              <div className="flex flex-wrap items-center justify-center gap-6">
                <a href={`mailto:${siteInfo.email}`} className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-lg"></i>
                  {siteInfo.email}
                </a>
                <span className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-phone-line text-lg"></i>
                  {siteInfo.phone}
                </span>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}